<template>
  <el-dialog title="TA Configuration" :visible.sync="dialogVisible" :scrollbar="false" width="700px" @open="onOpen"
    @closed="onClosed">
    <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">
      Add
    </el-button>
    <el-table :data="tableTAList" v-loading="taListLoading" element-loading-text="Loading..."
      header-row-class-name="table-header">
      <el-table-column prop="taConfigName" label="TA NAME" min-width="250" />
      <el-table-column prop="status" label="Status" min-width="250">
        <template slot-scope="{ row }">
          <el-switch v-model="row.status" disabled active-color="#d52b1e" inactive-color="#f2f3f6">
          </el-switch>
          {{ row.status ? '可用' : '不可用' }}
        </template>
      </el-table-column>
      <el-table-column prop="options" label="Operation" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleEdit(row)">
            编辑
          </el-button>|
          <el-button type="text" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  name: "EditConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      taList: [],
      taListLoading: false,
      dialogVisible: this.visible,
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  computed: {
    tableTAList() {
      return this.taList.map(item => {
        return {
          taConfigName: item.taConfigName,
          status: item.status == 1,
          taConfigId: item.taConfigId
        }
      })
    }
  },
  methods: {
    initList() {
      this.taListLoading = true
      this.axios
        .get('/sys/taConfig')
        .then(({ code, msg, data }) => {
          this.taListLoading = false
          if (code === 200) {
            this.taList = data
          } else {
            this.$message.error(msg);
          }
        }).catch(() => {
          this.taListLoading = false
        });
    },
    handleAdd() {
      this.taInfoDialogVisible = true
      this.title = 'Add TA'
      this.form = {
        taConfigId: "",
        taConfigName: '',
        status: 1
      }
      this.$emit('openInfo', this.title, this.form)
    },
    handleEdit(row) {
      this.taInfoDialogVisible = true
      this.title = 'Edit TA'
      this.form = row
      this.$emit('openInfo', this.title, this.form)
    },
    handleDelete(row) {
      this.$msgbox({
        title: '提示',
        message: `是否确认删除${row.taConfigName}，此操作会删除所有相关用户的TA?`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.axios
              .post('/sys/deleteTa', {
                taConfigId: row.taConfigId
              }).then(res => {
                if (res.code === 200) {
                  done()
                  instance.confirmButtonLoading = false
                  this.$message.success(`Delete successfully`);
                  this.initList()
                } else {
                  instance.confirmButtonLoading = false
                  this.$message.error(res.msg)
                }
              })
              .catch(() => {
                instance.confirmButtonLoading = false
                instance.close()
              })
          } else {
            done()
            instance.confirmButtonLoading = false
          }
        }
      })
    },
    onSave() {
      console.log(this.form)
      this.taInfoDialogVisible = false
    },
    onOpen() {
      this.initList()
    },
    onClosed() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0 10px 10px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
}

.el-form {
  width: 100%;
}

.dialog-footer {
  text-align: center;
}

.video-size {
  margin-left: 10px;
}

.el-icon-view {
  color: #909399;
  font-size: 14px;
  cursor: pointer;

  &:hover,
  &.active {
    color: $theme-color;
  }
}

.el-button+.el-button {
  margin-left: 0;
}
</style>
